import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import get from "lodash/get";
import { oneTapLogin } from "../helper/api";
import "./one-tap-login.m.css";

function OneTapLogin(props) {
  const [display, setDisplay] = useState(false);

  const onOneTapSignedIn = response => {
    console.log({ response });
    oneTapLogin(response.credential).then(res => {
      console.log({ res });
      window.localStorage.setItem("one-tap-display", false);
      window.location.reload();
    });
  };

  console.log({ display });

  useEffect(() => {
    console.log({ member: props.member });
    const scriptTag = document.createElement("script");
    scriptTag.src = "https://accounts.google.com/gsi/client";
    scriptTag.addEventListener("load", () => {
      google.accounts.id.initialize({
        client_id:
          "766089827850-3lfqip6dd01q3v06egtcgbf6c6sdvr5h.apps.googleusercontent.com",
        callback: onOneTapSignedIn
      });
      if (window.localStorage.getItem("one-tap-display") === "true")
        google.accounts.id.prompt(notification => {
          if (notification.isDisplayed()) {
            setDisplay(true);
          }
        });
    });
    scriptTag.async = true;
    document.querySelector("head").appendChild(scriptTag);
  }, []);

  if (display === true)
    return (
      <div styleName="overlay" onClick={() => setDisplay(false)}>
        <div styleName="wrapper">
          <div styleName="img-wrapper">
            <img
              style={{ height: "5rem", borderRadius: "5px" }}
              src="https://images.assettype.com/newslaundry/2020-10/fe2dc714-ad63-43b8-a43f-999fd1f9c7bc/qiMQgIos_400x400.png"
            />
          </div>
          <div styleName="text-wrapper">
            <h2>Sign in for a Seamless Experience</h2>
            <ul>
              <li>Access our feature-laden podcast player</li>
              <li>
                Gift access to paywall stories to friends. Subscribers only.
              </li>
              <li>Read paywall content without any friction</li>
            </ul>
          </div>
          <img
            style={{ height: "5rem", borderRadius: "5px" }}
            src="https://img.etimg.com/photo/msid-73174975,quality-100/photo.jpg"
          />
        </div>
      </div>
    );
  else return null;
}

function mapStateToProps(state) {
  return {
    userSubscription: get(state, ["hasSubscripton"], {}),
    member: get(state, ["member"], null)
  };
}

export default connect(mapStateToProps)(OneTapLogin);
